/* The Stores area (docs/plans/phase1-stock.md §5). Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.sectionHeading {
  font: var(--t-heading);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

/* A page-sized form on its own card (receive goods, transfer, adjustment): the card fills the
 * width and each field keeps its own maximum, so nothing is squeezed to the left. */
.wideForm {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.row > * {
  flex: 1 1 10rem;
  min-width: 0;
}

/* One line of a delivery, transfer or adjustment. Often a fieldset: no browser frame. */
.line {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
  margin: 0;
  padding: var(--space-4) 0;
  border: 0;
  border-bottom: 1px solid var(--rule);
}

.line > legend {
  float: left;
  width: 100%;
  padding: 0;
}

.lineHeading {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--space-3);
  font: var(--t-body-strong);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.meta {
  color: var(--graphite);
  font: var(--t-small);
}

.numbers {
  font-variant-numeric: tabular-nums;
}

.total {
  font: var(--t-body-strong);
  font-variant-numeric: tabular-nums;
}

.pickerRow {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0 var(--space-4);
  width: 100%;
}

.pickerName {
  font: var(--t-body-strong);
  overflow-wrap: anywhere;
}

.pickerMeta {
  grid-column: 1 / -1;
  color: var(--graphite);
  font: var(--t-small);
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-1) var(--space-4);
  margin: 0;
}

.facts dt {
  font: var(--t-body-strong);
}

.facts dd {
  margin: 0;
}

/* Stock on hand on a phone (DESIGN.md §10, lookups): the item, what is usable and its
 * state. Expired stock, the next expiry and the reorder level stay on wider screens. */
@media (width < 600px) {
  .onHand th:nth-child(n + 3):not(:last-child),
  .onHand td:nth-child(n + 3):not(:last-child) {
    display: none;
  }

  .onHand table[role='grid'] {
    min-width: 0;
  }
}

/* Views of one area: a segmented control made of links (ADR 0019). */
.subnav {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  width: fit-content;
  max-width: 100%;
  padding: 3px;
  border-radius: var(--radius-control);
  background: var(--wash);
}

.subnav a {
  display: inline-flex;
  align-items: center;
  min-height: calc(var(--control-height) - 8px);
  padding: 0 var(--space-3);
  border-radius: calc(var(--radius-control) - 2px);
  color: var(--pencil);
  text-decoration: none;
  white-space: nowrap;
  transition:
    background-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}

.subnav a:hover {
  color: var(--ink);
}

.subnav a[aria-current='page'] {
  background: var(--paper);
  box-shadow: var(--shadow-pill);
  color: var(--brand);
  font-weight: 500;
}
